import { render, staticRenderFns } from "./FrontendPerfil.vue?vue&type=template&id=25d0e990"
import script from "./FrontendPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontendPerfil.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports